import React from 'react';
import loadable from '@loadable/component';

const LongTermDurationPicker = loadable(() =>
  import('@justpark/ui/src/components/LongTermDurationPicker')
);

const LazyLongTermDurationPicker = props => (
  <LongTermDurationPicker {...props} fallback={<div>Loading...</div>} />
);

export default LazyLongTermDurationPicker;
